import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, renderList as _renderList, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "row no-wrap justify-between" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "option-name" }
const _hoisted_4 = { class: "label-boxes" }
const _hoisted_5 = {
  key: 0,
  class: "actions"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_select = _resolveComponent("q-select")!
  const _component_label_box = _resolveComponent("label-box")!
  const _component_TrashIcon = _resolveComponent("TrashIcon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["product-option-card", { editing: _ctx.editing }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (!_ctx.editing)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(_toDisplayString(_ctx.productOption.name), 1)
              ], 64))
            : (_openBlock(), _createBlock(_component_q_select, {
                key: 1,
                label: _ctx.selectedPropChoice || _ctx.inputValue ? undefined : 'Choose or create a property',
                "model-value": _ctx.selectedPropChoice,
                options: _ctx.filterOptions,
                onInputValue: _cache[0] || (_cache[0] = ($event: any) => (_ctx.selectedPropChoice = $event)),
                onFilter: _ctx.selectFilter,
                "input-debounce": "0",
                "new-value-mode": "add-unique",
                "popup-content-style": "padding: 0;",
                ref: "qSelect",
                "use-input": "",
                outlined: "",
                dense: "",
                "hide-selected": "",
                "fill-input": "",
                "emit-value": ""
              }, null, 8, ["label", "model-value", "options", "onFilter"]))
        ]),
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.propValues[_ctx.productOption.sys.id] ?? [], (value) => {
            return (_openBlock(), _createBlock(_component_label_box, {
              key: value,
              "model-value": value
            }, null, 8, ["model-value"]))
          }), 128))
        ])
      ]),
      (_ctx.editing)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_component_TrashIcon, {
              class: "remove",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('remove:product-option'))),
              size: "22px"
            })
          ]))
        : _createCommentVNode("", true)
    ])
  ], 2))
}